import React from 'react';
import useMediaQuery from './useMediaQuery';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';

function Header({ isMenuOpen, setIsMenuOpen }) {
  const isMobile = useMediaQuery('(max-width: 1524px)');

  return isMobile ? (
    <HeaderMobile isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
  ) : (
    <HeaderDesktop />
  );
}

export default Header;
